<template>

	<div :class="{ modal: true }">

		<div class="modal-wrap">

			<div class="modal-inner">

				<Loading v-if="loading!==''" position="inner" :text="loading" />

				<h2 class="modal-title">{{ showTitle }}<span class="close" @click="close()">X</span></h2>

				<div class="modal-inner-scroll">

					<form :class="{form:true,error:!!this.error}" @submit.prevent="submit">

						<label v-if="allKeywords.keywords.length>0" v-html="allKeywords.keywords.length>1?('For these '+allKeywords.keywords.length+' keywords...'):'For the following keyword...'" />

						<div v-if="allKeywords.keywords.length>0" class="selected-keywords">

							<span 
						        v-for="(kw, kwIndex) in allKeywords.keywords" 
						        :key="'kw-'+kwIndex" 
						        v-html="kw"
							/>

						</div>

						<hr v-if="allKeywords.keywords.length>0" style="margin-top: 0;" />

						<div class="option-wrap" v-if="alertsProcessed.length>1&&id===''">

							<label>New Alert Or Add To A Current One?</label>
							<v-select 
					            v-model="currentAlert" 
					            :options="alertsProcessed" 
					            :reduce="option => option._id"
					            :append-to-body="true"
					        />

						</div>

						<div class="option-wrap">

							<FormInput 
								type="text" 
								v-model="name"  
								name="name" 
								label="Alert Name"
								:required="false"
								:noMarginBottom="true"
							/>

						</div>

						<hr />

						<div class="option-wrap">

							<label v-html="allKeywords.keywords.length>0?'Which Project?':'Which Project(s)?'" />
							<v-select 
					            v-model="projects" 
					            :options="projectListProcessedAll" 
					            :reduce="option => option._id"
					            :append-to-body="true"
								:multiple="true"
								:disabled="allKeywords.keywords.length>0"
					        />

						</div>

						<hr />

						<div class="option-wrap" v-if="allProjectsSelected">

							<label v-html="'Exclude Projects?'" />
							<v-select 
					            v-model="excludeProjects" 
					            :options="projectListProcessed" 
					            :reduce="option => option._id"
					            :append-to-body="true"
								:multiple="true"
					        />

						</div>

						<hr v-if="allProjectsSelected" />

						<span class="option-wrap" v-if="allKeywords.keywords.length===0">

							<label>Which Keywords?</label>
							<Tip :styles="{ 'font-size': '12px', 'display': 'inline-block', 'margin-bottom': '10px', 'margin-top': '1px', 'vertical-align': 'top' }" class="filter-tip"><span v-html="allKeywords.keywords.length>0?'As well as the keywords selected above':'If you want to add individual keywords to an alert you can do so by going to the project page, selecting the relevant keywords (by ticking the box next to each) and then clicking the &quot;Add Alert&quot; button (this will then prompt you to create a new alert or add them to a current one).'" /></Tip>
							<v-select 
					            v-model="notifyLevel" 
					            :options="[{ _id: 'project', label: 'All Keywords In ' + projectName },{ _id: 'tags', label: 'Associated With Tag(s)' }]" 
					            :reduce="option => option._id"
					            :append-to-body="true"
					        />

							<TagsPreview 
								:tags="tags"
								:availableTags="availableTagsProcessed"
								@save="saveTags"
								description="You'll get alerts about any keywords in this project associated with the selected tags."
								v-if="notifyLevel==='tags'"
								class="tag-preview"
							/>

						</span>

						<hr v-if="allKeywords.keywords.length===0" />

						<div class="option-wrap">

							<label>Frequency</label>
							<Tip :styles="{ 'font-size': '12px', 'display': 'inline-block', 'margin-bottom': '10px', 'margin-bottom': '10px', 'margin-top': '1px', 'vertical-align': 'top' }" class="filter-tip"><span v-html="'How often do you want to receive this alert?'" :fromRight="true" /></Tip>
							<v-select 
					            v-model="frequency" 
					            :options="[{ _id: 'off', label: 'Never (Off)' },{ _id: 'daily', label: 'Daily' },{ _id: 'weekly', label: 'Weekly' },{ _id: 'monthly', label: 'Monthly' }]" 
					            :reduce="option => option._id"
					            :append-to-body="true"
					        />

					    </div>

					    <hr v-if="fullAccess" />

					    <div class="option-wrap" v-if="fullAccess">

							<label>Recipient(s)</label>
							<Tip :styles="{ 'font-size': '12px', 'display': 'inline-block', 'margin-bottom': '10px', 'margin-bottom': '10px', 'margin-top': '1px', 'vertical-align': 'top' }" class="filter-tip"><span v-html="'Who should this alert be sent to? Any email addresses added will be sent an email to confirm they are correct, if an alert doesn\'t have any confirmed email address the alert will be sent to the email associated with this account.'" /></Tip>
							
							<v-select 
					            v-model="recipients" 
					            :options="availableEmailsProcessed" 
					            :reduce="option => option._id"
					            :append-to-body="true"
								:searchable="false"
					            :multiple="true"
					            placeholder="Select an email address(es)"
					            v-if="availableEmailsProcessed.length>0"
					        ></v-select>

							<FormInput 
								type="text" 
								v-model="newEmail"  
								name="recipient" 
								placeholder="Add a new recipient email address"
								:required="false"
								:noMarginBottom="true"
							/>

							<span 
								class="add-new email" 
								v-if="newEmail!==''"
								v-html="'Add Email'"
								@click="addEmail"
							/>

							<span class="email-error" v-if="emailError!==''" v-html="emailError" />

					    </div>

					    <hr />

						<label>Rules</label>
						<Tip :styles="{ 'font-size': '12px', 'display': 'inline-block', 'margin-bottom': '10px', 'margin-bottom': '10px', 'margin-top': '1px', 'vertical-align': 'top' }" class="filter-tip"><span v-html="'What needs to have happened to a keywords position for you to be notified about it?'" /></Tip>

						<div class="rule-list">

							<p class="how-to" v-if="rules.length>0">Click the words in bold to toggle through the options, click the numbers to enter a new one.</p>

							<div 
								class="rule"
						        v-for="(rule, ruleIndex) in rules" 
						        :key="'rule-'+ruleIndex" 
							>

								Where the keyword has 
								<span v-html="rule.climbedFallen" @click="toggleRule('climbedFallen',ruleIndex)" />
								<span class="just-text" v-if="rule.climbedFallen!=='moved'">by at least</span> 
								<span class="just-text" v-if="rule.climbedFallen==='moved'">to</span> 
								<span v-if="rule.climbedFallen!=='moved'" :class="[{'input-wrap':true},inputWrapClass(null,ruleIndex)]"><input @focus="inputWrapClass(true,ruleIndex)" @blur="inputWrapClass(false,ruleIndex)" type="text" v-model="rule.climbedFallenAmount" :class="inputClasses(rule.climbedFallenAmount)" :ref="'rule-input-'+ruleIndex" @click="focusInput('rule-input-'+ruleIndex)" maxlength="3" @keypress="isNumber($event)" @keyup="numberChange ($event,ruleIndex)" /></span> 
								<span><span v-html="rule.climbedFallenType" @click="toggleRule('climbedFallenType',ruleIndex)" /><span v-if="rule.climbedFallenAmount!=='1'&&rule.climbedFallen!=='moved'">s</span></span>
								<span :class="[{'input-wrap':true},inputWrapClass(null,ruleIndex)]" v-if="rule.climbedFallen==='moved'"><input @focus="inputWrapClass(true,ruleIndex)" @blur="inputWrapClass(false,ruleIndex)" type="text" v-model="rule.climbedFallenAmount" :class="inputClasses(rule.climbedFallenAmount)" :ref="'rule-input-'+ruleIndex" @click="focusInput('rule-input-'+ruleIndex)" maxlength="3" @keypress="isNumber($event)" @keyup="numberChange ($event,ruleIndex)" /></span> 
								<span class="just-text" v-if="rule.climbedFallen!=='moved'">compared to a  
								<span v-html="rule.sinceType" @click="toggleRule('sinceType',ruleIndex)" /> ago</span> 
								
								<span class="delete" @click="deleteRule(ruleIndex)">X</span>

								<div class="current-rules" v-if="rule.climbedFallen!=='moved'">

									<div 
										class="current-rule"
								        v-for="(currentRule, currentRuleIndex) in rule.currentRules" 
								        :key="'current-rule-'+currentRuleIndex" 
									>

										<span class="just-text" v-if="currentRuleIndex===0">and the previous </span><span v-if="currentRuleIndex===0" v-html="currentRule.currentType" @click="toggleRule('currentType', ruleIndex, currentRuleIndex)" /> <span v-if="currentRuleIndex===0">was</span><span v-if="currentRuleIndex>0">and</span> <span v-html="currentRule.currentCompare==='<'?'less':'greater'" @click="toggleRule('currentCompare', ruleIndex, currentRuleIndex)" /> than or equal to <span :class="[{'input-wrap':true},inputWrapClass(null,ruleIndex,currentRuleIndex)]"><input type="text" @focus="inputWrapClass(true,ruleIndex,currentRuleIndex)" @blur="inputWrapClass(false,ruleIndex,currentRuleIndex)" v-model="currentRule.currentAmount" :class="inputClasses(currentRule.currentAmount)" :ref="'current-rule-input-'+currentRuleIndex" @keypress="isNumber($event)" @keyup="numberChange ($event,ruleIndex,currentRuleIndex)" @click="focusInput('current-rule-input-'+currentRuleIndex)" maxlength="3" /></span> 

										<span class="delete" @click="deleteRule(ruleIndex,currentRuleIndex)" v-if="!inputWrapClasses[ruleIndex].currents[currentRuleIndex]">X</span>

									</div>

									<span 
										class="add-new" 
										@click="addNewRuleCurrentRule (ruleIndex)" 
										v-if="rule.currentRules.length<2"
										v-html="rule.currentRules.length===0?'Add a filter about the keywords previous page/position':'Add more'"
									/>

								</div>

							</div>

							<span @click="addNewRule" class="add-new rule">Add A New Rule</span>

						</div>

					</form>

				</div>

				<span class="large-button" @click="submit" v-html="weEditing ? 'Update' : 'Add Alert'" />

				<p v-if="error!==''" class="error" v-html="error" />

			</div>

		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import FormInput from './Form/Input.vue'
import Loading from './Loading.vue'
import TagsPreview from './TagsPreview.vue'
import Tip from './Tip.vue'
export default {
	name: 'Alerts',
	props: {
		project: {
			type: String
		},
		id: {
			type: String,
			default: ""
		},
		keywords: {
			type: Object,
			default: function () { return { keywords: [], _ids: [] } }
		}
	},
	components: {
		FormInput,
		Loading,
		TagsPreview,
		Tip
	},
	data() {

		return {
			loading: '',
			projects: [],
			recipient: '', 
			notifyLevel: 'project',
			currentAlert: 'new',
			notes: '',
			error: '',
			name: '',
			newEmail: '',
			frequency: 'daily',
			tags: [],
			availableTags: [],
			availableEmails:[],
			recipients: ['account'],
			rules: [],
			excludeProjects: [],
			alerts:{ items: [] },
			inputWrapClasses: {},
			editing: null,
			emailError: '',
			keywordsCurrent: { keywords: [], _ids: [] }
		}

	},
	watch: {
		currentAlert: function (new1, old1) {

			if ( new1 !== old1 ) {

				this.recipient = '';
				this.notifyLevel = 'project';
				this.name = '';
				this.projects = [];
				this.frequency = 'daily';
				this.rules = [];
				this.editing = null;

				if ( new1 !== 'new' ) {

					let a = this.alerts.items.find( a => a._id.toString() === new1 );

					if ( a ) {

						this.editing = a._id.toString();

						this.processAlertData (a,['keywords']);

					}

				}

			}

		},
		recipients: function (new1, old1) {
			
			if ( new1.length === 0 ) {

				this.recipients.push('account');

			}

		},
		frequency: function (n, o) {
			
			console.log(o,typeof o, n,typeof n);

		},
		projects() {

			if ( this.allProjectsSelected && this.projects.length > 1 ) {

				this.projects = ['all'];

			}

		}
	},
	computed: { 

		...mapState('general',['projectList','projectListLoaded','userInfo']),

		fullAccess () {

			return this.userInfo && this.userInfo.access === 'full-access';

		},

		projectName () {

			if ( !this.projects.length ) return '';

			if ( this.allProjectsSelected ) return 'All Projects';

			if ( this.projects.length === 1 ) {

				let p = this.projectList.find( p => p._id === this.projects[0] );

				return p.name;

			}

			return ' The ' + this.projects.length + ' Selected Projects';

		},

		availableTagsProcessed () {

			let tags = [];

			this.availableTags.forEach( function (t) {

				if ( !this.allProjectsSelected && this.projects.indexOf( tag.project ) < 0 ) return;

				tags.push(t.tag);

			}.bind(this));

			return tags;

		},

		projectListProcessed () {

			let projects = [];

			this.projectList.forEach ( function (p) {

				projects.push({ _id: p._id, label: p.name });

			});

			return projects;

		},
		projectListProcessedAll () {

			let projects = general.stripObject( this.projectListProcessed );

			projects.unshift({ _id: 'all', label: 'All Projects' });

			return projects;

		},

		allProjectsSelected () {

			return this.projects.indexOf('all') > -1;

		},

		allKeywords () {

			let k = { 
				keywords: this.keywordsCurrent.keywords, 
				_ids: general.stripObject( this.keywords._ids )
			};

			['_ids','keywords'].forEach( function (type) {

				this.keywords[type].forEach( function (kw,index) {

					let found = this.keywordsCurrent[type].find( kw2 => kw2 === kw );

					if ( !found ) {

						k[type].push( kw );

					}

				}.bind(this));

			}.bind(this));

			return k;

		},

		availableEmailsProcessed () {

			let availableEmails = [{ _id: 'account', label: "Account email" }];

			this.availableEmails.forEach( function (availableEmail) {

				let email = availableEmail.confirmed ? availableEmail.email : ( availableEmail.email + ' (not confirmed!)' );

				availableEmails.push({ _id: availableEmail._id, label: email });

			});

			return availableEmails;

		},

		showTitle () {

			let t = ( this.weEditing ? 'Update ' : 'Add An Alert ' );

			return t + ( this.name ? ( " - " + this.name ) : ( this.projectName ? ( "For " + this.projectName ) : '' ) );

		},
		keywordsProcessed () {

			let keywords = [];

			this.allKeywords.keywords.forEach ( function (k) {

				keywords.push( k );

			});

			return keywords.join(', ');

		},
		alertsProcessed () {

			let alerts = [{ _id: 'new', label: 'Add A New Alert' }];

			this.alerts.items.forEach( function (alert) {

				if ( !alert.allProject ) alerts.push({ _id: alert._id, label: alert.name });

			}.bind(this));

			return alerts;

		},
		weEditing () {

			return this.id !== '' ? this.id : this.editing !== null ? this.editing : null;

		},
		queryString () {

			let queryString = ['perPage=1000','sortBy=nameLowercase','sortDir=1'];

			if ( this.project ) {

				queryString.push('project=' + this.project);
				queryString.push('hasKeywords=1' );

			}

			if ( queryString.length > 0 ) return '?' + queryString.join('&');

			return '';

		},

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		okToAdd () {

			let errors = [];

			if ( this.name === '' ) errors.push('An Alert Name');
			if ( this.frequency === null ) errors.push('A Frequency');
			if ( this.rules.length === 0 ) errors.push('At Least 1 Rule');
			if ( this.notifyLevel === 'tags' && this.tags.length === 0 ) errors.push('At Least 1 Rule');

			if ( errors.length > 0 ) {

				this.error = "Missing: " + errors.join(', ');

			}

			return errors.length === 0;

		},

		addEmail () {

			this.loading = 'One moment...';
			this.emailError = '';

			ApiService.post( 'alerts/email-addresses', {  email: this.newEmail } )
			.then( function( info ) {

				this.availableEmails = info.data;

				let em = this.availableEmails.find( email => email.email == this.newEmail.toLowerCase() );

				if ( em ) {

					this.recipients.push(em._id);

				}

				this.loading = '';

				this.emailError = 'An email has been sent to ' + this.newEmail + ', please ask them to click the link in it to confirm.';

				this.newEmail = '';

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.emailError = err.response.data.error;

			}.bind(this));

		},

		inputWrapClass(type,ruleIndex,currentRuleIndex) {

			if ( typeof this.inputWrapClasses[ruleIndex] === 'undefined' ) Vue.set(this.inputWrapClasses,ruleIndex,{ currents: {}, focus: false });

			if ( typeof currentRuleIndex !== 'undefined' && typeof this.inputWrapClasses[ruleIndex].currents[currentRuleIndex] === 'undefined' ) Vue.set(this.inputWrapClasses[ruleIndex].currents,currentRuleIndex,false);

			if ( type === null ) return typeof currentRuleIndex !== 'undefined' ? { focus: this.inputWrapClasses[ruleIndex].currents[currentRuleIndex] } : { focus: this.inputWrapClasses[ruleIndex].focus };
			else {

				if ( typeof currentRuleIndex !== 'undefined' ) {

					Vue.set(this.inputWrapClasses[ruleIndex].currents,currentRuleIndex,type);

				}
				else {

					Vue.set(this.inputWrapClasses[ruleIndex],'focus',type);

				}

			}

		},

		deleteRule (ruleIndex,currentRuleIndex) {

			if ( typeof currentRuleIndex !== 'undefined' ) {

				this.rules[ruleIndex].currentRules.splice(currentRuleIndex, 1);

			}
			else {

				this.rules.splice(ruleIndex, 1);

			}

		},

		numberChange (evt,ruleIndex,currentRuleIndex) {
			evt = (evt) ? evt : window.event;
			let charCode = (evt.which) ? evt.which : evt.keyCode;



			let n = this.rules[ruleIndex],  
				type = 'climbedFallenType',
				amount = 'climbedFallenAmount';

			if ( typeof currentRuleIndex !== 'undefined' ) {

				n = n.currentRules[currentRuleIndex];
				type = 'currentType';
				amount = 'currentAmount';

			}

			let max = ( n[type] !== 'page' ) ? 100 : 10,
				v = parseInt( n[amount] );

			charCode === 38 && ++v;

			charCode === 40 && --v;

			if ( v < 1 ) v = 1;
			else if ( v > max ) v = max;

			if ( v !== parseInt( n[amount] ) ) {

				v += '';

				if ( typeof currentRuleIndex !== 'undefined' ) {

					this.rules[ruleIndex].currentRules[currentRuleIndex][amount] = v;

				}
				else {

					this.rules[ruleIndex][amount] = v;

				}

			}

		},

		isNumber (evt) {

			evt = (evt) ? evt : window.event;
			let charCode = (evt.which) ? evt.which : evt.keyCode;

			if (charCode > 31 && (charCode < 48 || charCode > 57)) {

				evt.preventDefault();

			} else {

				return true;

			}
		},

		focusInput(ref) {

			this.$refs[ref][0].select();

		},

		inputClasses (n) {

			let c = {}, l = ( n + '' ).length > 8 ? 8 : ( n + '' ).length;

			c['length-' + l] = true;

			return c;

		},

		addNewRule () {

			this.rules.push({
				climbedFallen: 'climbed',
				climbedFallenAmount: '1',
				climbedFallenType: 'page',
				sinceAmount: '1',
				sinceType: 'day',
				currentRules:[]

			});

		},

		addNewRuleCurrentRule (ruleIndex) {

			let t = 'page', c = '<', n = 2;

			if ( this.rules[ruleIndex].currentRules.length > 0 ) {

				t = this.rules[ruleIndex].currentRules[0].currentType;
				c = this.rules[ruleIndex].currentRules[0].currentCompare === '<' ? '>' : '<';
				n = this.rules[ruleIndex].currentRules[0].currentAmount;

			}

			this.rules[ruleIndex].currentRules.push({
				currentType: t,
				currentCompare: c,
				currentAmount: n + ''
			});

		},

		toggleRule(type,ruleIndex,currentRuleIndex) {

			let ops = [];

			switch (type) {

				case 'climbedFallen' :
					ops = ['moved','climbed','fallen']; break;
				case 'climbedFallenType' :
				case 'currentType' :
					ops = ['page','position']; break;
				case 'sinceType' :
					ops = ['day','week','month']; break;
				case 'currentCompare' :
					ops = ['<','>']; break;

			}

			let c = typeof currentRuleIndex !== 'undefined' ? this.rules[ruleIndex].currentRules[currentRuleIndex][type] : this.rules[ruleIndex][type];

			let index = ops.indexOf( c ) + 1;

			if ( index === ops.length ) index = 0;

			if ( typeof currentRuleIndex !== 'undefined' ) {

				this.rules[ruleIndex].currentRules[currentRuleIndex][type] = ops[index];

			}
			else {

				this.rules[ruleIndex][type] = ops[index];

			}

		},

		saveTags (info) {

			this.tags = info;

		},

		displayError(error) {

			this.errors = error ? error.message : '';

		},
		joinAnd (arr) {

			if ( arr.length < 2 ) return arr[0]; 

			let l = arr.pop();

			return arr.join(', ') + ' &amp; ' + l;

		},

		submit() {

			if ( !this.okToAdd() ) return;

			let info = {
				name: this.name,
				project: this.projects,
				notifyLevel: this.notifyLevel,
				keywords: this.allKeywords._ids,
				tags: this.tags,
				recipients: this.recipients,
				rules: this.rules,
				frequency: this.frequency,
				excludeProjects: this.excludeProjects
			};
			
			this.error = "";

			this.loading = this.weEditing ? "Updating Alert" : "Adding Alert";

			ApiService.post( 'alerts' + ( this.weEditing ? ( '/' + this.weEditing ) : '' ), info )
			.then( function( info ) {

				this.loading = '';
				this.close(true);

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.error = "There was an error";

			}.bind(this));

		},

		close(update) {

			this.$emit('close',update);

		},
		processAlertData (data,ignores) {

			ignores = Array.isArray(ignores) ? ignores : [];

			['name','rules','recipients','frequency','notifyLevel','tags'].forEach ( function (t) {

				if ( ignores.indexOf(t) >= 0 ) return;

				data[t] && Vue.set( this, t, data[t] );

			}.bind(this));

			if ( data.allProjects ) {

				this.projects = ['all'];

				this.excludeProjects = [];

				data.excludeProjects.forEach( function ( projectId ) {

					const f = this.projectList.find( p => p._id === projectId );

					if ( f ) this.excludeProjects.push( projectId );

				}.bind(this));

			}
			else {

				data.project.forEach( function ( projectId ) {

					const f = this.projectList.find( p => p._id === projectId );

					if ( f ) this.projects.push( projectId );

				}.bind(this));

				if ( this.project && this.projects.indexOf( this.project ) ) {

					this.projects.push( this.project );

					if ( this.projects.length > 1 ) {

						const f = this.projectList.find( p => p._id === this.project );

						this.$snotify.success( f.name + ' will be added to the selected projects for this alert.', 'Projects Updated');

					}

				}

			}

			if ( data.sendToAccountEmail ) {

				this.recipients.push('account');

			}

			this.keywordsCurrent = data.keywords;

		}
	},
	mounted() {

		if ( this.id ) {

			this.loading = 'One moment...';

			ApiService.get( 'alerts/' + this.id )
			.then( function( info ) {

				this.processAlertData (info.data);

				this.loading = '';

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.error = "There was an error";

			}.bind(this));

		}
		else if ( this.project ) {

			this.projects.push( this.project );

		}

		if ( this.allKeywords._ids.length > 0 ) {

			this.loading = 'One moment...';

			ApiService.get( 'alerts' + this.queryString )
			.then( function( info ) {

				this.alerts = info.data;

				this.loading = '';

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.error = "There was an error";

			}.bind(this));

		}

		ApiService.get( 'keywords/tags' )
		.then( function( info ) {

			this.availableTags = info.data;

		}.bind(this))
		.catch( function(err) {

			this.error = "There was an error";

		}.bind(this));

		if ( this.fullAccess ) {

			ApiService.get( 'alerts/email-addresses' )
			.then( function( info ) {

				this.availableEmails = info.data;

			}.bind(this))
			.catch( function(err) {

				this.error = "There was an error";

			}.bind(this));

		}

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
@imgRoot:'../assets/';
.modal {

	.modal-inner {

		&:before {

			display: none;

		}

		form {

			padding-bottom: 70px;

			&.error {

				padding-bottom: 130px;

			}

			label {

				display: inline-block;

			}

		}

		p {
			padding: 0;
			margin: 0 0 20px 0;
			font-size: 14px;

			&.info {

				padding: 0;
				margin: 0 0 7px;
				color: @formDefaultColour;

			}

			&.error {

				background-color: @red;
			    margin: 20px 20px 0 0;
			    color: #fff;
			    padding: 10px;
			    border-radius: 5px;
				position: absolute;
    			bottom: 20px;
				z-index: 3;
				left: 22px;
				max-width: 50%;

			}
		}

		.option-wrap {

			margin-bottom: 20px;
			display: block;

		}

		.selected-keywords {

			margin: 5px 0 15px;
			max-height: 100px;
			overflow-x: auto;

			span {

				border: 2px solid @formDefaultColour;
				color: @formDefaultColour;
				display: inline-block;
				vertical-align: top;
				margin: 0 5px 5px 0;
				padding: 3px 7px;
				.rounded(5px);

			}

		}

		.large-button {

			position: absolute;
			right: 20px;
			bottom: 20px;
			z-index: 3;

		}

		span {

			&.email-error {

				color: @red;

			}

			&.add-new, &.delete {

				color: #fff;
				margin-top: 3px;
				background-color: @formDefaultColour;
				border: 1px solid @formDefaultColour;
				font-weight: normal;
				font-size: 14px;
				padding: 2px 6px;
				border-radius: 5px;
				display: inline-block;
				cursor: pointer;

				&:hover {

					background-color: #fff;
					color: @formDefaultColour;

				}

				&.email {

					margin-top: 12px;

				}

			}

			&.delete {

				font-size: 12px;
				padding: 1px 5px;
				cursor: pointer;
				.rounded(50%);
				background: url('@{imgRoot}img/close2.svg') center center no-repeat;
			    transition: transform .5s ease-in-out;
			    .indent;
			    width: 20px;
			    height: 20px;
			    background-size: 24px;
				border: none;
				margin: 0 0 0 5px;
				vertical-align: text-bottom;

				&:hover {

					transform: rotate(180deg);

				}

			}

			span {

				color: inherit;

			}

			&.input-wrap {
				
				position: relative;
				overflow: visible;

				&:after {

					content: "Type a number";
					font-size: 10px;
					position: absolute;
					z-index: 2;
					color: @formDefaultColour;
					left: 50%;
				    top: -14px;
				    width: 100px;
				    margin-left: -50px;
				    text-align: center;
				    display: none;

				}

				&.focus {

					&:after {

						display: block;

					}

				}

			}

		}

		.rule-list {

			.how-to {

				margin: 0 0 12px;
				color: @formDefaultColour;

			}

			.rule {

				margin-bottom: 20px;

				[type=text] {

					background: none;
					padding: 0;
					display: inline-block;
					text-align: center;
					width: 14px; 
					margin: 0;
					padding: 0;
					font: inherit;
					border:none;
					cursor: pointer;
					font-weight: @bold;
					position: relative;

					&.length-2 {
						width: 24px;
					}

					&.length-3 {
						width: 34px;
					}

					&.length-4 {
						width: 44px;
					}

					&.length-5 {
						width: 54px;
					}

					&.length-6 {
						width: 64px;
					}

					&.length-7 {
						width: 74px;
					}

					&.length-8 {
						width: 84px;
					}

				}

				span {

					&:not(.input-wrap):not(.just-text) {

						font-weight: @bold;
						cursor: pointer;

						&:hover {
				
							color: @formDefaultColour;

						}

					}
						
				}

				.current-rules {

					margin-left: 20px;

					.current-rule {

						span {

							&.input-wrap {

								&:after {

									right: -103px;
								    left: auto;
								    top: 3px;
								    margin: 0;
								    text-align: left;

								}

							}

							&:not(.input-wrap):not(.just-text) {

								font-weight: @bold;
								cursor: pointer;

								&:hover {
				
									color: @formDefaultColour;

								}

							}

						}

					}

				}

			}

		}

	}

}
@media screen and (min-width: 480px) {

	.modal {

		.modal-inner {

			form {

				&.error {

					padding-bottom: 70px;

				}

				p {

					&.error {

						bottom: 20px;
						margin-right: 160px;

					}

				}

			}

		}

	}

}
</style>